(function () {
  if (document.documentElement.lang !== "en") return;


  const dictionary = (window.shopTranslations || []).sort((a, b) => b.fr.length - a.fr.length);
  const cache = {};
  let throttleTimer = null;


  function fixDates(text) {
    if (!text.toLowerCase().includes("il y a")) return text;
    return text.replace(/il y a/gi, "").replace(/un(e)?/gi, "1").replace(/semaine(s)?/gi, "week$1").replace(/mois/gi, "months").replace(/an(s)?/gi, "year$1").replace(/jour(s)?/gi, "day$1").replace(/heure(s)?/gi, "hour$1").trim() + " ago";
  }


  async function translateText(text) {
    if (!text || text.length < 2) return text;
    let out = fixDates(text);
   
    let foundInDict = false;
    dictionary.forEach(pair => {
      const regex = new RegExp(pair.fr, "gi");
      if (regex.test(out)) {
        out = out.replace(regex, pair.en);
        foundInDict = true;
      }
    });


    if (!foundInDict && /[àâçéèêëîïôûùüÿœ]/i.test(out)) {
      const trimmed = out.trim();
      if (cache[trimmed]) return cache[trimmed];
      try {
        const res = await fetch("https://translate.googleapis.com/translate_a/single?client=gtx&sl=fr&tl=en&dt=t&q=" + encodeURIComponent(trimmed));
        const data = await res.json();
        const translated = data[0].map(x => x[0]).join("");
        cache[trimmed] = translated;
        return translated;
      } catch (e) { return out; }
    }
    return out;
  }


  async function processPage() {
    // 1. Target Placeholders (fixes "Votre email" and "Demandez moi")
    document.querySelectorAll('input, textarea').forEach(async (el) => {
      const p = el.getAttribute("placeholder");
      if (p) {
        const trans = await translateText(p);
        if (trans !== p) el.setAttribute("placeholder", trans);
      }
    });


    // 2. Target Popup elements and Buttons (fixes "SUR VOTRE COMMANDE" and "NON MERCI")
    document.querySelectorAll('div, span, button, p, b').forEach(async (el) => {
      if (el.children.length === 0 && el.innerText.trim().length > 0) {
        const original = el.innerText;
        const trans = await translateText(original);
        if (trans !== original) el.innerText = trans;
      }
    });


    // 3. General Text Node Walker
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    let node;
    while(node = walker.nextNode()) {
      if (node.parentElement && !["SCRIPT", "STYLE", "NOSCRIPT"].includes(node.parentElement.tagName)) {
        const original = node.nodeValue;
        const trans = await translateText(original);
        if (trans !== original) node.nodeValue = trans;
      }
    }
  }


  const observer = new MutationObserver(() => {
    if (throttleTimer) return;
    throttleTimer = setTimeout(() => {
      processPage();
      throttleTimer = null;
    }, 150);
  });


  // Watch for everything, including when a popup adds new attributes like "placeholder"
  observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true });
 
  processPage();
  setTimeout(processPage, 500);
  setTimeout(processPage, 2000);
})();

